"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileSessionList = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const closeButton_svg_1 = __importDefault(require("../../../../assets/icons/closeButton.svg"));
const useScrollEndListener_1 = require("../../../../hooks/useScrollEndListener");
const SessionListTile_1 = require("../SessionsListTile/SessionListTile");
const S = __importStar(require("./MobileSessionList.style"));
const MobileSessionList = ({ sessions, onCellClick, onClose, onScrollEnd, fetchableSessionsCount, isIndoor, isDormant, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const sessionListRef = (0, react_1.useRef)(null);
    const results = sessions.length;
    const handleClick = (id, streamId) => {
        if (onCellClick) {
            onCellClick(id, streamId);
        }
    };
    (0, useScrollEndListener_1.useScrollEndListener)(sessionListRef, onScrollEnd);
    return (react_1.default.createElement(S.Overlay, null,
        react_1.default.createElement(S.VerticalContainer, null,
            react_1.default.createElement(S.HorizontalContainer, null,
                react_1.default.createElement(S.ImageButton, { onClick: onClose },
                    react_1.default.createElement(S.Image, { src: closeButton_svg_1.default, alt: t("map.altClose") })),
                react_1.default.createElement(S.Title, null, t("map.mobileResults", { results, fetchableSessionsCount }))),
            react_1.default.createElement(S.SessionListStyled, { ref: sessionListRef, "data-testid": "mobile-session-list-items-container" }, sessions.map((session) => (react_1.default.createElement("div", { key: session.id },
                react_1.default.createElement(SessionListTile_1.SessionsListTile, { id: session.id, sessionName: session.sessionName, sensorName: session.sensorName, averageValue: session.averageValue, startTime: session.startTime, endTime: session.endTime, streamId: session.streamId, isIndoor: isIndoor, isDormant: isDormant, onClick: (id, streamId) => {
                        handleClick(id, streamId);
                    } }))))))));
};
exports.MobileSessionList = MobileSessionList;
